export enum EventActionTypeEnum {
  CopyLink = "copyLink",
  Share = "share",
  AddToWatchlist = "addToWatchlist",
  RemoveFromWatchlist = "removeFromWatchlist",
}
